import { useIntl } from 'react-intl';

import { Icon } from '@/components/Icon';
import { useRouter } from '@/hooks/useRouter';
import { commonMessages } from '@/messages/common';

import * as M from './messages';
import * as S from './ShoppingBagHeaderDesktop.styles';

interface ShoppingBagHeaderDesktopProps {
  showBackLink?: boolean;
}

export const ShoppingBagHeaderDesktop = ({
  showBackLink = false,
}: ShoppingBagHeaderDesktopProps) => {
  const { formatMessage } = useIntl();
  const { paths } = useRouter();

  return (
    <S.Wrapper data-test-id='ShoppingBagHeaderDesktopWrapper'>
      <S.ContinueShopping
        data-test-id='ShoppingBagHeaderDesktopContinueShopping'
        isUpperCase={false}
        label={M.ContinueShopping}
        leftContent={<Icon name='chevronLeft' />}
        linkProps={{ href: paths.watches.url() }}
        show={showBackLink.toString()}
        variant='link'
        width='auto'
      />
      <S.Header
        data-test-id='ShoppingBagHeaderDesktopHeader'
        text={formatMessage(commonMessages.shoppingBag)}
      />
    </S.Wrapper>
  );
};
